import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import {reactive} from "vue";
import {editor} from "@/app/editor";
import {GroupModuleV1} from "@/app/editor/modules/group/v1/index";
import {DeleteOutlined} from "@ant-design/icons-vue";
import BlockContentItemKey from "@/components/block/BlockContentItemKey.vue";
import BlockContentItemValue from "@/components/block/BlockContentItemValue.vue";
import BlockContentBox from "@/components/block/BlockContentBox.vue";
import GroupProductsTableView from "@/app/editor/modules/group/v1/view/GroupProductsTableView.vue";
import ValidInputNumber from "@/app/editor/modules/group/v1/view/ValidInputNumber.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GroupStepGoods',
  props: {
    index: {}
  },
  setup(__props: any) {


const props = __props
const group = editor.activity?.modules[props.index] as GroupModuleV1

const info = reactive({active: group.config.steps.map((_, i) => i)})

const addStep = () => {
  group.config.steps.push({
    group_size: (group.config.steps.last()?.group_size ?? 0) + 2,
    price: 0,
    items: [],
    total_value: 0
  })
  info.active = group.config.steps.map((_, i) => i)
}

return (_ctx: any,_cache: any) => {
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BlockContentBox, null, {
      default: _withCtx(() => [
        _createVNode(BlockContentItemKey, null, {
          default: _withCtx(() => [
            _createTextVNode("团购价")
          ]),
          _: 1
        }),
        _createVNode(BlockContentItemValue, null, {
          default: _withCtx(() => [
            _createVNode(ValidInputNumber, {
              placeholder: "点击输入团购价",
              max: 999,
              min: 0.1,
              "addon-after": "元",
              value: _unref(group).config.goods.sell_price,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(group).config.goods.sell_price) = $event)),
              onChange: _cache[1] || (_cache[1] = v => _unref(group).config.steps.forEach(i => i.price=v)),
              valid: v => v<=0 ? '未设置' : null
            }, null, 8, ["value", "valid"])
          ]),
          _: 1
        }),
        _createVNode(BlockContentItemKey, null, {
          default: _withCtx(() => [
            _createTextVNode("库存数量")
          ]),
          _: 1
        }),
        _createVNode(BlockContentItemValue, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_number, {
              placeholder: "点击输入库存数量",
              max: 9999,
              min: 1,
              "addon-after": "个",
              value: _unref(group).config.goods.stock,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(group).config.goods.stock) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(BlockContentItemKey, null, {
          default: _withCtx(() => [
            _createTextVNode("团长免单")
          ]),
          _: 1
        }),
        _createVNode(BlockContentItemValue, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_switch, {
              checked: _unref(group).config.goods.leader_free,
              "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_unref(group).config.goods.leader_free) = $event))
            }, null, 8, ["checked"]),
            _hoisted_1,
            _createVNode(_component_a_typography_text, { type: "secondary" }, {
              default: _withCtx(() => [
                _createTextVNode("开启后只有最高阶梯成团，团长才免单，系统不处理免单，店家自行处理 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_collapse, {
      "active-key": info.active,
      "onUpdate:activeKey": _cache[5] || (_cache[5] = ($event: any) => ((info.active) = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(group).config.steps, (s, i) => {
          return (_openBlock(), _createBlock(_component_a_collapse_panel, {
            key: i,
            header: `第${['','一','二','三','四'][i+1]}阶梯`
          }, {
            extra: _withCtx(() => [
              _createVNode(_component_a_popconfirm, {
                title: "确认删除此阶梯么？",
                disabled: _unref(group).config.steps.length<=2,
                onConfirm: () => _unref(group).config.steps.splice(i,1)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                    disabled: _unref(group).config.steps.length<=2
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DeleteOutlined))
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 2
              }, 1032, ["disabled", "onConfirm"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_flex, {
                vertical: "",
                gap: "middle"
              }, {
                default: _withCtx(() => [
                  _createVNode(BlockContentBox, null, {
                    default: _withCtx(() => [
                      _createVNode(BlockContentItemKey, null, {
                        default: _withCtx(() => [
                          _createTextVNode("成团人数")
                        ]),
                        _: 1
                      }),
                      _createVNode(BlockContentItemValue, null, {
                        default: _withCtx(() => [
                          _createVNode(ValidInputNumber, {
                            placeholder: "点击输入成团人数",
                            max: 99,
                            min: 2,
                            "addon-after": "人",
                            onChange: () => {_unref(group).config.steps.forEach((s,k) => {if (k> i) s.group_size = 0})},
                            value: s.group_size,
                            "onUpdate:value": ($event: any) => ((s.group_size) = $event),
                            valid: v => v < 2 ? '未设置' : i>0 ? _unref(group).config.steps[i-1].group_size>=v ? '成团人数必须高于上一阶梯' : null : null
                          }, null, 8, ["onChange", "value", "onUpdate:value", "valid"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  (_openBlock(), _createBlock(GroupProductsTableView, {
                    key: i,
                    items: s.items,
                    "onUpdate:items": ($event: any) => ((s.items) = $event)
                  }, null, 8, ["items", "onUpdate:items"]))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["header"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["active-key"]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_button, {
        size: "large",
        type: "primary",
        disabled: _unref(group).config.steps.length>=4,
        onClick: addStep
      }, {
        default: _withCtx(() => [
          _createTextVNode("添加商品阶梯 ")
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(GroupProductsTableView, {
      items: _unref(group).config.fail_items,
      "onUpdate:items": _cache[6] || (_cache[6] = ($event: any) => ((_unref(group).config.fail_items) = $event)),
      "is-fail": ""
    }, null, 8, ["items"])
  ], 64))
}
}

})